'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bar = function (_Component) {
  (0, _inherits3.default)(Bar, _Component);

  function Bar(props) {
    (0, _classCallCheck3.default)(this, Bar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Bar.__proto__ || (0, _getPrototypeOf2.default)(Bar)).call(this, props));

    _this.state = {
      doAnimate: false
    };
    return _this;
  }

  (0, _createClass3.default)(Bar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          doAnimate: true
        });
      }, 300);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          value = _props.value;


      return _react2.default.createElement(
        'div',
        {
          className: 'bar-container'
        },
        _react2.default.createElement(
          'p',
          null,
          label
        ),
        _react2.default.createElement(
          'div',
          { className: 'bar-item' },
          _react2.default.createElement(
            'div',
            { className: 'bar', style: { width: Math.round((this.state.doAnimate ? value : 0) * 100) + '%' } },
            _react2.default.createElement(
              'div',
              { className: 'value' },
              Math.round(value * 100),
              '%'
            )
          )
        )
      );
    }
  }]);
  return Bar;
}(_react.Component);

exports.default = Bar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobChart/Bar.jsx
// module id = 1179
// module chunks = 0